module.exports = __webpack_public_path__ + "static/innovation.bad1d280.jpeg";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/2022/photos/a-propos/innovation.jpeg
// module id = 910
// module chunks = 3